import { Component, inject, signal } from '@angular/core';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ActivatedRoute, RouterModule } from '@angular/router';

import { Location } from '@angular/common';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationComponent } from '../../../components/navigation/navigation.component';
import { AuthService } from '../../../services/auth.service';
import { OfficeService } from '../../../services/office.service';

@Component({
  selector: 'app-password-reset',
  standalone: true,
  imports: [
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatCardModule,
    ReactiveFormsModule,
    RouterModule,
    NavigationComponent,
  ],
  templateUrl: './password-reset.component.html',
  styleUrl: './password-reset.component.scss',
})
export class PasswordResetComponent {
  private route: ActivatedRoute = inject(ActivatedRoute);
  location: Location = inject(Location);
  $routeParams = toSignal(this.route.queryParamMap);
  showRegister: boolean = false;
  $authError = signal('');
  $result = signal('');
  private authService = inject(AuthService);
  private officeService = inject(OfficeService);
  form = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
    password: new FormControl('', [Validators.required]),
    officeName: new FormControl(''),
    contactData: new FormControl(''),
  });

  onCancel() {
    console.log('path', this.location.path(true));

    if (this.location.path(true).includes('switch')) {
      const id: any = this.$routeParams()?.get('id');
      console.log('switch ' + id);
      this.officeService.getOffice(id);
    } else {
      // this.location.back();
    }
  }
  onReset() {
    console.log('onReset');

    this.$authError.set('');
    this.form.markAllAsTouched();
    if (this.form.controls.email.valid && this.form.controls.email.value !== undefined) {
      this.authService
        .sendResetLink(this.form.controls.email.value!.toString())
        .then(() => {
          console.log('Passwort-Reset-E-Mail wurde gesendet!');
          this.$result.set(
            'Wir haben Ihnen eine Email an die angegebene Adresse gesendet. Bitte klicken Sie den Link, in dieser Email, um Ihr Passwort zurückzusetzen.'
          );
        })
        .catch(error => {
          console.error('Fehler beim Senden der Passwort-Reset-E-Mail:', error);
          this.$authError.set(error.message);
        });
    }
  }
}
